import React, {Component} from 'react';

class Services extends Component {
    render() {
        return (
            <section id="what-we-do" className="custom-pt-1 custom-pb-2 bg-dark position-relative"
                     data-bg-img={require(`../../assets/images/bg/02.png`)}>
                <div className="container">
                    <div className="row align-items-end">
                        <div className="col-lg-4 col-md-6 mb-8 mb-lg-0 text-white">
                            <div> <span className="badge badge-primary-soft p-2">
                                <i className="la la-shield-alt ic-3x rotation"/>
                            </span>
                                <h2 className="mt-3 mb-0">Enterprise-Grade Identity Verification Suite</h2>
                                <p className="lead text-white mt-3">Complete verification workflow in one unified platform</p>
                            </div>
                        </div>
                        <div className="col-lg-4 col-md-6">
                            <div className="bg-primary-soft rounded p-5">
                                <div className="d-flex align-items-center mb-4">
                                    <div className="mr-3">
                                        <img className="img-fluid" src={require(`../../assets/images/icon/01.svg`)}
                                             alt=""/>
                                    </div>
                                    <h5 className="m-0 text-light">Biometric Verification</h5>
                                </div>
                                <p className="mb-0">AI-powered facial recognition with 99.9% accuracy. Compare live selfies against ID photos using multiple advanced models optimized for different security levels.</p>
                            </div>
                        </div>
                        <div className="col-lg-4 col-md-6 mt-6 mt-md-0">
                            <div className="bg-primary-soft rounded p-5">
                                <div className="d-flex align-items-center mb-4">
                                    <div className="mr-3">
                                        <img className="img-fluid" src={require(`../../assets/images/icon/02.svg`)}
                                             alt=""/>
                                    </div>
                                    <h5 className="m-0 text-light">Anti-Spoofing Technology</h5>
                                </div>
                                <p className="mb-0">95% fraud detection rate with advanced liveness detection. Identify printed photos, screen replays, masks, and deepfakes with multi-layered AI analysis.</p>
                            </div>
                        </div>
                        <div className="col-lg-4 col-md-6 mt-6">
                            <div className="bg-primary-soft rounded p-5">
                                <div className="d-flex align-items-center mb-4">
                                    <div className="mr-3">
                                        <img className="img-fluid" src={require(`../../assets/images/icon/03.svg`)}
                                             alt=""/>
                                    </div>
                                    <h5 className="m-0 text-light">Document Intelligence</h5>
                                </div>
                                <p className="mb-0">Automated authenticity verification detecting photocopies, forgeries, and tampered documents. Support for 100+ ID types with MRZ parsing and data extraction.</p>
                            </div>
                        </div>
                        <div className="col-lg-4 col-md-6 mt-6">
                            <div className="bg-primary-soft rounded p-5">
                                <div className="d-flex align-items-center mb-4">
                                    <div className="mr-3">
                                        <img className="img-fluid" src={require(`../../assets/images/icon/04.svg`)}
                                             alt=""/>
                                    </div>
                                    <h5 className="m-0 text-light">Real-Time Processing</h5>
                                </div>
                                <p className="mb-0">GPU-optimized architecture delivering verification results in under 400ms. Queue-based system scales horizontally for millions of daily verifications.</p>
                            </div>
                        </div>
                        <div className="col-lg-4 col-md-6 mt-6">
                            <div className="bg-primary-soft rounded p-5">
                                <div className="d-flex align-items-center mb-4">
                                    <div className="mr-3">
                                        <img className="img-fluid" src={require(`../../assets/images/icon/05.svg`)}
                                             alt=""/>
                                    </div>
                                    <h5 className="m-0 text-light">Developer-Friendly API</h5>
                                </div>
                                <p className="mb-0">Simple RESTful API with comprehensive documentation. Deploy in minutes with SDKs for popular languages and frameworks. Webhooks for asynchronous workflows.</p>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="shape-1" style={{height: '150px', overflow: 'hidden'}}>
                    <svg viewBox="0 0 500 150" preserveAspectRatio="none" style={{height: '100%', width: '100%'}}>
                        <path d="M0.00,49.98 C150.00,150.00 271.49,-50.00 500.00,49.98 L500.00,0.00 L0.00,0.00 Z"
                              style={{stroke: 'none', fill: '#fff'}}/>
                    </svg>
                </div>
                <div className="shape-1 bottom" style={{height: '200px', overflow: 'hidden'}}>
                    <svg viewBox="0 0 500 150" preserveAspectRatio="none" style={{height: '100%', width: '100%'}}>
                        <path d="M0.00,49.98 C150.00,150.00 349.20,-50.00 500.00,49.98 L500.00,150.00 L0.00,150.00 Z"
                              style={{stroke: 'none', fill: '#fff'}}/>
                    </svg>
                </div>
            </section>

        );
    }
}

export default Services;
